import React from 'react'
import { AppSealDTO } from '../../../providers/environment/types'
import { RunOnceEffect } from '../../../utils/Utils'
import { DescriptionStyled, LicenceContainerStyled } from '../styled'

export const AppSealAnjouan = (props: AppSealDTO): React.ReactElement => {
    RunOnceEffect(() => {
        if (props.token) {
            try {
                // @ts-ignore
                window.anj_f1f16b12_c1ea_41c4_9dc4_d615d383cdc8.init()
            } catch (e) {}
        }
    })

    return (
        <>
            <LicenceContainerStyled className={'app-seal'}>
                {!props.noImage && (
                    <div
                        id={props.id}
                        data-emr-seal-id={props.sealId}
                        data-emr-image-size={props.imageSize}
                        data-emr-image-type={props.imageType}
                    ></div>
                )}
                {props.label && !props.noText && <DescriptionStyled dangerouslySetInnerHTML={{ __html: props.label }} />}
            </LicenceContainerStyled>
        </>
    )
}
